var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({staticClass:"button",on:{"click":_vm.clicked}},'button',_vm.$attrs,false),[(_vm.icon)?_c('span',{staticClass:"icon is-small"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }